export default "__VITE_ASSET__BD$K90_b__"